import base from "./base"
import { backend_api_v2 } from "/src/utils/apiv2"
import { defineStore } from 'pinia'

export const useIntegrationsStore = defineStore('integrations', {
    state: () => ({
        webhooks: [],
    }),
    getters: {
        // No getters
    },
    actions: {
        // Webhooks
        setWebhooks: base.actions.setter("webhooks"),
        createWebhook: base.actions.creator("webhooks"),
        updateWebhook: base.actions.updater("webhooks"),
        removeWebhook: base.actions.remover("webhooks"),

        // Webhooks
        loadWebhooks: base.actions.loader("integrations/webhooks/", "Webhooks"),
        postWebhook: base.actions.poster("integrations/webhooks/", "Webhook"),
        putWebhook: base.actions.putter("integrations/webhooks/", "Webhook"),
        deleteWebhook: base.actions.deleter("integrations/webhooks/", "Webhook"),

        // The recorded calls of one webhook. Not kept in the store: it is a
        // log read on demand from one dialog, and it would go stale the moment
        // the next event fires.
        // A new signing secret; the old one stops working at once.
        rotateWebhookSigningSecret(uuid) {
            return backend_api_v2
                .post(`integrations/webhooks/${uuid}/rotate_signing_secret/`)
                .then(({ data }) => {
                    this.updateWebhook(data)
                    return data
                })
        },
        loadWebhookDeliveries(uuid) {
            return backend_api_v2
                .get(`integrations/webhooks/${uuid}/deliveries/`)
                .then(({ data }) => data)
        },
    },
})
